import { render, staticRenderFns } from "./ElBlogAuthorBox.vue?vue&type=template&id=0e7b97fc"
import script from "./ElBlogAuthorBox.vue?vue&type=script&lang=js"
export * from "./ElBlogAuthorBox.vue?vue&type=script&lang=js"
import style0 from "./ElBlogAuthorBox.vue?vue&type=style&index=0&id=0e7b97fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports